import { Box, Tag, Text } from '@televet/kibble-ui';
import React from 'react';
import { FormQuestionType } from 'shared/types/forms';
import { Maybe } from 'shared/types/graphql';
import { formatPhoneNumber } from 'shared/utils';
import { FormAnswer } from './FormAnswer';
import { FormAnswersContainer } from './FormAnswersContainer';
import { FormAnswerWithContent } from './FormAnswerWithContent';
import { Prescription, RequestFormInput } from './types';

export type ParsedFormContent = Record<
  string,
  { name: string; prescriptions?: Prescription[]; note?: string; form?: { questions: RequestFormInput[] } }
>;

type MultiPetAnswersProps = {
  primaryPhoneNumber: Maybe<string>;
  parsedFormContent: ParsedFormContent;
  small?: boolean;
  borderLeftColor?: string;
  showNewClientTag?: boolean;
};

export const MultiPetAnswers = ({
  parsedFormContent,
  primaryPhoneNumber,
  small,
  borderLeftColor,
  showNewClientTag,
}: MultiPetAnswersProps): JSX.Element => {
  const Pets = { ...parsedFormContent };
  const PetIds = Object.keys(parsedFormContent);

  return (
    <Box>
      {showNewClientTag && (
        <Box>
          <Tag variant="success" label="New Client" size="sm" />
        </Box>
      )}
      {Boolean(primaryPhoneNumber) && (
        <FormAnswer question="Phone Number">{formatPhoneNumber(primaryPhoneNumber)}</FormAnswer>
      )}
      {PetIds.map((id) => {
        const prescriptions = Pets[id]?.prescriptions || [];
        const hasPrescriptions = !!prescriptions.length;
        return (
          <FormAnswersContainer key={id + 'name'} borderLeftColor={borderLeftColor} small={small}>
            <FormAnswer question="Selected Pet:">{Pets[id].name}</FormAnswer>

            {hasPrescriptions && (
              <FormAnswer key="prescriptions" question="Prescriptions Requested:" small={small}>
                {prescriptions.map((rx: Prescription, index: number) => (
                  <Text as="p" fontWeight="bold" key={rx.id}>
                    {(index + 1).toString() + '. ' + rx.description}
                  </Text>
                ))}
              </FormAnswer>
            )}

            {Pets[id].note && (
              <FormAnswer
                key={id + 'note'}
                question={hasPrescriptions ? 'Prescriptions Note:' : 'No Prescriptions Message:'}
                small={small}
              >
                {Pets[id].note}
              </FormAnswer>
            )}

            {Pets[id].form?.questions
              ?.filter(
                (question: RequestFormInput) =>
                  question.type !== FormQuestionType.ratingInput && question.type !== FormQuestionType.textBlock,
              )
              .map((question: RequestFormInput, index: number) => (
                <FormAnswerWithContent small={small} key={index} question={question} />
              ))}
          </FormAnswersContainer>
        );
      })}
    </Box>
  );
};
